<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <ModalCatedra
        :typeForm="typeForm"
        :catedra="catedra"
        :activarModal="activarModal"
        :cambioForm="cambioForm"
        @listarCatedras="getCatedras"
      ></ModalCatedra>

      <div class="row justify-content-center">
        <div class="col-lg-12">
          <card
            type="secondary"
            shadow
            header-classes="bg-white pb-12"
            body-classes="px-lg-12 py-lg-12"
            class="border-0"
          >
            <h2 style="float:left">Listado de cátedras</h2>

            <base-button
              type="primary"
              icon="ni ni-fat-add"
              size="lg"
              
              @click="crearForm"
              style="float:right;margin-botton:12px"
              >Crear cátedra</base-button
            >
            <table
              class="table table-bordered table-dark"
              style="margin-top: 60px;"
            >
              <thead>
                <tr>
                  <th scope="col">Nombre</th>
                  <th scope="col">F. inicio</th>
                  <th scope="col">Inscripciones</th>
                  <th scope="col">Ubicación</th>
                  <th scope="col">Profesor</th>
                  <th scope="col">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(catedra, index) in catedras" :key="index">
                  <td v-text="catedra.nombre"></td>
                  <td v-text="catedra.fecha_inicio"></td>
                  <td v-text="statusInscripcion(catedra.inscripciones)"></td>                  
                  <td v-text="catedra.ubicacion"></td>
                  <td v-text="catedra.coordinador"></td>
                  <td style="display:inline-flex;border-top:none;border-right:none">
                    <!-- <base-button
                      type="warning"
                      icon="ni ni-settings"
                      size="sm"
                      @click="activar(catedra)"
                    ></base-button> -->

                    <!-- <base-button
                      type="warning"
                      icon="ni ni-settings"
                      size="sm"
                      @click="editarForm(catedra)"
                    ></base-button>
                    <base-button
                      type="danger"
                      icon="ni ni-fat-delete"
                      size="sm"
                      @click="eliminarCatedra(catedra)"
                    ></base-button> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </card>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ModalCatedra from "./ModalCatedra";
export default {
  components: {
    ModalCatedra,
  },
  name:"Catedras",
  data() {
    return {
      catedras: [],
      typeForm: "",
      catedra: [],
      activarModal: false,
      cambioForm: "",
      facilitadores:[]
    };
  },
  created() {
    this.getCatedras();
    this.getFacilitadores();
  },
  methods: {
    async getCatedras() {
      this.activarModal = false;
      try {
        const { data } = await this.$api.get("chairs");
        this.catedras = data.data;
      } catch (error) {
        console.log("hubo un error al cargar las catedras");
      }
    },
    async getFacilitadores(){
      try {
        const { data } = await this.$api.get("facilitators");
        this.facilitadores = data.data;
      } catch (error) {
        console.log("hubo un error al cargar las catedras");
      }

    },
    crearForm() {
      this.activarModal = true;
      this.cambioForm =
        Math.random()
          .toString(36)
          .substring(2, 15) +
        Math.random()
          .toString(36)
          .substring(2, 15);
      this.typeForm = "Crear";
    },
    async editarForm(catedra) {
      this.activarModal = true;
      this.cambioForm =
        Math.random()
          .toString(36)
          .substring(2, 15) +
        Math.random()
          .toString(36)
          .substring(2, 15);
      this.typeForm = "Editar";
      this.catedra = catedra;
    },
    async eliminarCatedra(catedra){      
        var url = "chairs/" + catedra.id;
        var method = "delete";
      
      try {
        await this.$api({
          url: url,
          method: method,
          
        });
      } catch (e) {
        if (e.response == "422") {
          console.log("422" + " " + e);
        } else {
          console.log(e);
        }
      }
      this.getCatedras();

    },
    statusInscripcion(status){
        if (status ==0 ) {
            return 'Cerradas'
        }
        return 'Abiertas'

    }
  },
  watch: {
    /*modalActive: function (val) {
      if (this.typeForm === 'Crear') {
        this.typeForm = 'Editar'        
      }else{
        this.typeForm = 'Crear';
      }
    }*/
  },
};
</script>
